var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import { runtime } from '../../../../classes/runtime/Runtime';
import { Scene } from '../../../../classes/learnware/LearnwareEnums';
let AbfragerAdBottom = class AbfragerAdBottom extends React.PureComponent {
    render() {
        const { app } = this.props;
        if (!runtime.availablePackages.Defer)
            return null;
        const { DfpAd } = runtime.availablePackages.Defer.components;
        if (app.stage.stageInnerMeasure.stageWidthInPixel < 780)
            return null;
        if (app.stage.stageScene.currentScene === Scene.CycleEnd)
            return null;
        return (React.createElement("div", { style: {
                minHeight: 95,
                display: 'flex',
                justifyContent: 'center',
                border: '2px solid #333333',
                textAlign: 'center',
                borderRadius: 10,
                backgroundColor: '#F5F5F5',
                paddingLeft: 12,
                paddingRight: 12,
                paddingTop: 2,
                paddingBottom: 3,
                marginBottom: 3
            } }, runtime.availablePackages.Defer && React.createElement(DfpAd, { app: app })));
        /*
        return (
          <div
            style={{
              minHeight: 105,
              marginTop: 12,
              border: '2px solid #333333',
              textAlign: 'center',
              borderRadius: 10,
              backgroundColor: '#F5F5F5',
              paddingLeft: 12,
              paddingRight: 12,
              paddingTop: 5,
              paddingBottom: 8
            }}
          >
            <GoogleAd app={app} slotId={5569387500} />
          </div>
        ); */
    }
};
AbfragerAdBottom = __decorate([
    observer
], AbfragerAdBottom);
export { AbfragerAdBottom };
